/* eslint-disable react/prop-types */
import { useEffect } from 'react';
import { useFormikContext } from 'formik';
import { useSelector } from 'react-redux';
import { selectAllComboBoxOptions } from '@redux/selectors/FormSelector';

const ComboEnforcer = props => {
  const parentFields = [
    'City',
    'CountyOrParish',
    'PropertySubType',
    'SubdivisionName',
  ];

  const {
    valueBubble, opt, FieldName,
  } = props;

  const allComboBoxOptions = useSelector(selectAllComboBoxOptions); // used to gather target children when parent changes

  const { values } = useFormikContext(); // used to check the set displayed values

  useEffect(() => {
    if (opt) { // enforcer is running.
      // a governing field has changed, select the options that need to be checked.
      if (parentFields.includes(FieldName)) { // a governor has changed
        const targetComboOptions = allComboBoxOptions.map(aCBO => {
          const found = aCBO.data.map(singleOption => {
            let isTargetOption = false;
            let target = null;
            if ('Parents' in singleOption) {
              singleOption.Parents.map(parent => {
                if (parent.ParentField === FieldName) {
                  isTargetOption = true;
                }
                return null;
              });
            }

            if (isTargetOption === true) {
              target = singleOption;
            } return target;
          });

          return { lookupFieldName: aCBO.lookupFieldName, found };
        });

        // filter the target options out of the dirty array
        const filteredTargets = [];

        if (targetComboOptions.length > 0) {
          targetComboOptions.map(tgt => {
            const filteredOptions = tgt.found.filter(fOpt => fOpt !== null);
            if (filteredOptions.length > 0) filteredTargets.push({ lookupFieldName: tgt.lookupFieldName, filteredOptions });
            return null;
          });
        }

        // manipulate targeted data. => clear out any values that have been set.
        if (filteredTargets.length > 0) { // ensure that there's anything to check
          filteredTargets.map(tgtOpt => {
            const childOpt = values[tgtOpt.lookupFieldName];
            if (childOpt) {
              const foundChild = tgtOpt.filteredOptions.find(tData => tData.Code === childOpt);
              if (foundChild) {
                const targetParent = foundChild.Parents.find(parent => parent.ParentField === FieldName);
                if (!targetParent.ParentCodes.includes(opt.value)) {
                  valueBubble({ fieldName: tgtOpt.lookupFieldName, newValue: '' });
                }
              }
            }
            return null;
          });
        }

        // Manipulate the available options.
        const parentValue = values[FieldName];

        filteredTargets.map(fTarg => {
          fTarg.filteredOptions.map(fOpt => {
            let hasParent;

            fOpt.Parents.map(ftPar => {
              if (ftPar.ParentField === FieldName) {
                if (ftPar.ParentCodes.find(pc => pc === parentValue)) {
                  hasParent = true;
                }
              }

              const mOpt = fOpt;
              mOpt.ParentIsActive = hasParent;
              return null;
            });
            return null;
          });
          return null;
        });
      }
    }
  }, [opt]);
  return null;
};

export default ComboEnforcer;
